package co.maytes.standupbot.dashboard.pages.app.standups.sections

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.Card
import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideCalendar
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideClock
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideUsers
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import co.maytes.standupbot.shared.dto.standup.StandupDto
import co.maytes.standupbot.shared.util.RelativeTime
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.datetime.Clock

@Composable
internal fun StatsStrip(standup: StandupDto) {
    val now = Clock.System.now()
    val memberValue = "${standup.memberCount} ${if (standup.memberCount == 1) "member" else "members"}"
    val lastValue = standup.lastStandupAt?.let { RelativeTime.format(it, now) } ?: "No runs yet"
    val lastDim = standup.lastStandupAt == null
    val nextValue = when {
        !standup.enabled -> "Paused"
        standup.nextRunAt == null -> "Not scheduled"
        else -> RelativeTime.formatFuture(standup.nextRunAt!!, now)
    }
    val nextDim = !standup.enabled || standup.nextRunAt == null

    Row(
        modifier = Modifier.fillMaxWidth().styleModifier {
            property("gap", "12px")
            property("flex-wrap", "wrap")
        },
    ) {
        StatTile(label = "Members", value = memberValue, dim = false) { LucideUsers(size = 15) }
        StatTile(label = "Last run", value = lastValue, dim = lastDim) { LucideClock(size = 15) }
        StatTile(label = "Next run", value = nextValue, dim = nextDim) { LucideCalendar(size = 15) }
    }
}

@Composable
private fun StatTile(
    label: String,
    value: String,
    dim: Boolean,
    icon: @Composable () -> Unit,
) {
    Box(
        modifier = Modifier.styleModifier {
            property("flex", "1 1 180px")
            property("min-width", "160px")
        },
    ) {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .styleModifier { property("padding", "14px 16px") },
            padded = false,
        ) {
            Column(modifier = Modifier.gap(Spacing.xs)) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.gap(Spacing.xs),
                ) {
                    Box(
                        modifier = Modifier.styleModifier {
                            property("color", Palette.textTertiary.cssRgb())
                            property("display", "inline-flex")
                            property("flex-shrink", "0")
                        },
                    ) { icon() }
                    SpanText(
                        text = label,
                        modifier = Modifier
                            .fontSize(Typography.caption.size)
                            .fontWeight(600)
                            .color(Palette.textTertiary)
                            .styleModifier {
                                property("text-transform", "none")
                                property("letter-spacing", "0")
                            },
                    )
                }
                SpanText(
                    text = value,
                    modifier = Modifier
                        .fontSize(Typography.body.size)
                        .fontWeight(600)
                        .color(if (dim) Palette.textTertiary else Palette.textPrimary),
                )
            }
        }
    }
}
